import { render } from "./HomeView.vue?vue&type=template&id=323f2b5f&scoped=true&lang=pug"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=323f2b5f&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/cschool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323f2b5f"]])

export default __exports__